import { render } from "./OnzeMixedSecondData.vue?vue&type=template&id=2a703c14"
import script from "./OnzeMixedSecondData.vue?vue&type=script&lang=js"
export * from "./OnzeMixedSecondData.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\Vind\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__